import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackCancelOrderParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/order/trackCancelOrder";

const useTrackCancelOrder = (
    parameters: TrackCancelOrderParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.cancelOrder, parameters, options);
};

export default useTrackCancelOrder;
